import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Icon from '../components/icon'
import type { CasinoCategory } from '../constants/casino'

const useGameCategories = () => {
  const { t } = useTranslation('casino')

  const TABS = useMemo<
  Array<CasinoCategory>
  >(
    () => [
      {
        label: t('home'),
        path: 'inicio',
        value: '15665',
        img: <Icon id="popular" />,
      },
      {
        label: t('jackpots'),
        path: 'jackpots',
        value: '15656',
        img: <Icon id="jackpots" />,
      },
      {
        label: t('new'),
        path: 'nuevo',
        value: '15652',
        img: <Icon id="new" />,
      },
      {
        label: t('slots'),
        path: 'slots',
        value: '15647',
        img: <Icon id="slots" />,
      },
      {
        label: t('live'),
        path: 'en-vivo',
        value: '15650',
        img: <Icon id="live" />,
      },
      {
        label: t('cards'),
        path: 'cartas',
        value: '15649',
        img: <Icon id="table" />,
      },
      {
        label: t('bingo'),
        path: 'bingo',
        value: '15653',
        img: <Icon id="bingo" />,
      },
      {
        label: t('others'),
        path: 'otros',
        value: '15657',
        img: <Icon id="others" />,
      },
      {
        label: t('favorites'),
        path: 'favoritos',
        value: 'favorites',
        img: <Icon id="favorites" />,
      },
    ],
    [],
  )

  return { categories: TABS }
}

export default useGameCategories
